import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rescal',
  templateUrl: './rescal.component.html',
  styleUrls: ['./rescal.component.scss']
})
export class RescalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
